import { useEffect } from 'react';
import { auth } from '../firebase';
import { useAtom } from 'jotai';
import { userData, showAvailableState } from '../states/planner';
import { matchRoutes, useLocation } from 'react-router-dom';
import { isSignInWithEmailLink, onAuthStateChanged, signInWithEmailLink, signOut } from 'firebase/auth';
import { FirebaseError } from 'firebase/app';

import RadioButton from '../components/RadioButton';
import { FilterButton } from '../components/FilterButton';
import useSite from '../hooks/useSite';

// Top navbar
export default function NavBar() {
  const [user, setUser] = useAtom(userData);
  const [site] = useSite();

  const [showAvailable, setShowAvailable] = useAtom(showAvailableState);

  const location = useLocation();
  const routes = [{ path: '/:company/admin/*' }];

  const route = matchRoutes(routes, location);
  const routeParam = route ? route[0].params.company : '';
  const isAdminPage = routeParam;

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user && user.uid) {
        setUser({ id: user.uid });
      } else {
        setUser({ id: 'anonymous' });
      }
    });
  }, []);

  if (user && user.id === 'anonymous') {
    // User is null if useEffect have not run
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        email = window.prompt('Please provide your email for confirmation');
      }
      if (email) {
        signInWithEmailLink(auth, email, window.location.href)
          .then(() => {
            window.localStorage.removeItem('emailForSignIn');
            // setUser({ id: result.user.uid });
          })
          .catch((error: FirebaseError) => {
            throw new Error(error.message);
          });
      }
    }
  }
  function toggleShowAvailable(set?: boolean) {
    setShowAvailable(set || !showAvailable);
  }

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        setUser({ id: 'anonymous' });
      })
      .catch((error: FirebaseError) => {
        console.log(error);
        // An error happened.
      });
  };

  if (isAdminPage) {
    return (
      <header className="mb-2 mt-2">
        <nav>
          <ul className="flex flex-wrap justify-between">
            <li className="ml-3 mr-5 text-base font-extrabold">ADMIN PAGE</li>
            {user && user.id !== 'anonymous' && (
              <li className="mr-2 flex items-center text-xs md:mr-5 md:text-sm">
                <div className="flex justify-end">
                  <button onClick={() => handleSignOut()}>Sign out</button>
                </div>
              </li>
            )}
          </ul>
        </nav>
      </header>
    );
  }
  const titleText = () => {
    if (site.type === 'condominium') return 'Bostadsrätter';
    if (site.type === 'ownership') return 'Äganderätter';
    if (site.type === 'rental') return 'Hyresrätter';
  };

  const hideTitle =
    site?.statuslabels.available && site?.statuslabels.sold && site?.statuslabels.reserved && site?.statuslabels.extra;

  return (
    <header className="mt-2 sm:mb-1">
      <nav>
        <div className="flex flex-col justify-between sm:flex-row">
          <ul className="flex list-none sm:mt-0">
            <li className={`font-style-one ml-3 mr-2 font-bold sm:mr-5 ${hideTitle ? 'hidden sm:block' : ''}`}>
              {titleText()}
            </li>
            {hideTitle && <li className="mr-2 font-bold sm:mr-5"></li>}
            {site?.statuslabels.available && (
              <li className="mr-1 flex items-center text-xs sm:mr-2">
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" className="svg-circle-available" fill="#18974d" />
                </svg>
                <span className="whitespace-nowrap"> {site?.statuslabels.available}</span>
              </li>
            )}
            {site?.statuslabels.reserved && (
              <li className="mr-1 flex items-center text-xs sm:mr-2">
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" className="svg-circle-reserved" fill="orange" />
                </svg>
                {site?.statuslabels.reserved}
              </li>
            )}
            {site?.statuslabels.extra && (
              <li className="mr-1 flex items-center text-xs sm:mr-2">
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" className="svg-circle-extra" fill="cornflowerblue" />
                </svg>
                {site?.statuslabels.extra}
              </li>
            )}
            {site?.statuslabels.sold && (
              <li className="mr-1 flex items-center text-xs sm:mr-2">
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" className="svg-circle-sold" fill="#ec3326" />
                </svg>
                {site?.statuslabels.sold}
              </li>
            )}
          </ul>

          <hr className="ml-3 mr-3 h-px border-0 bg-black sm:ml-0 sm:mr-0" />
          <ul className="ml-3 mr-3 flex flex-grow list-none border-t p-0 sm:border-t-0">
            <li className="ml-auto h-6 font-bold">
              <button className="font-style-one whitespace-nowrap" onClick={() => toggleShowAvailable()}>
                {site.type === 'rental' ? 'Visa lediga lägenheter' : 'Visa bostäder till salu'}
              </button>
            </li>
            <li className="flex items-center">
              <RadioButton checked={showAvailable} action={() => toggleShowAvailable()} />
            </li>
            <FilterButton />
          </ul>
        </div>
      </nav>
    </header>
  );
}
